/**
 * STORT:s egna kontaktuppgifter — en källa för Dashboard, Hjälp-sidan och
 * underhållsläget. Samma uppgifter låg tidigare duplicerade på tre ställen med
 * inbördes olika tel:-länkar.
 */
export const CONTACT = {
  phone: '060 15 77 30',
  /** E.164 härlett ur det visade numret (060 15 77 30 → +46 60 157 730). */
  phoneHref: 'tel:+4660157730',
  email: 'info@stort.nu',
  street: 'Oljevägen 5',
  postalCity: '852 29 Sundsvall',
  mapsHref: 'https://www.google.com/maps/search/?api=1&query=Oljev%C3%A4gen+5%2C+852+29+Sundsvall%2C+Sweden',
  hoursLabel: 'Måndag - Fredag',
  hoursRange: '07:00 - 16:30',
} as const;

/** Öppettider i Europe/Stockholm: mån–fre 07:00–16:30. */
const OPEN_FROM_MINUTES = 7 * 60;
const OPEN_TO_MINUTES = 16 * 60 + 30;

/**
 * Är kontoret öppet just nu? Räknas alltid i svensk tid, oavsett klientens
 * tidszon. Helgdagar hanteras inte — vi har ingen helgdagskalender i frontend.
 * ponytail: veckodag + klockslag räcker; lägg till röda dagar när någon frågar.
 */
export const isOfficeOpen = (now: Date = new Date()): boolean => {
  const parts = new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Stockholm',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(now);

  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
  const weekday = get('weekday').toLowerCase();
  if (weekday.startsWith('lör') || weekday.startsWith('sön')) {
    return false;
  }

  const minutes = Number(get('hour')) * 60 + Number(get('minute'));
  return minutes >= OPEN_FROM_MINUTES && minutes < OPEN_TO_MINUTES;
};
